export default class Cliente {
	constructor(
		nome='',
        cpf='',
        data_nascimento='',
		cep='',
        bairro='',
        cidade='',
        estado='',
        logradouro='', 
        complemento=''
	){
		this.nome = nome;
        this.data_nascimento = data_nascimento;
        this.cpf = cpf;
		this.cep = cep;
        this.bairro = bairro;
        this.cidade = cidade;
        this.estado = estado;
        this.logradouro = logradouro;
        this.complemento = complemento;
	}
}